import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const DEFAULT_FORM = {
    title: ""
}

const PaymentType = () => {

    const [form, setForm] = useState(DEFAULT_FORM)

    const { addData: addConfig } = useEntityCrud("Config/update")
    const { readData } = useEntityCrud('Config/get');
    const [walletpayment, setWalletpayment] = useState("")


    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        const body = {
            "key": "walletpayment"
        }
        readData(body).then(({ data }) => {
            if (data.status)
             setWalletpayment(data.result.value)
        });
    }
 

    function handleSubmit(e) {
        debugger
        e.preventDefault();
        const body = {
            "value": walletpayment,
            "key": "walletpayment"
        }
        addConfig(body)
            .then(({ data }) => {
                debugger
                if (data.status) {
                    toast.success('عملیات مورد نظر با موفقیت انجام شد');
                } else
                    data.errors.map(error => toast.error(error.message));
            })
    }

 

    return (

        <div className=" baseInfo_" >
            <form onSubmit={handleSubmit} >
                <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>
                    <div className="col-md-12 pr-0">
                        <div className="form-group">



                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="form-label">   امکان پرداخت ترکیبی با کیف پول  </div>
                                    <div className="custom-controls-stacked d-flex my-4">
                                        <label className="custom-control custom-radio">
                                            <input
                                                type="radio"
                                                className="custom-control-input"
                                                name="example-radios"
                                                value="1"
                                                checked={walletpayment === "1"}
                                                onChange={(e) => setWalletpayment(e.target.value)} />
                                            <span className="custom-control-label">فعال</span>
                                        </label>
                                        <label className="custom-control custom-radio ms-auto">
                                            <input type="radio"
                                                className="custom-control-input"
                                                name="example-radios"
                                                value="0"
                                                checked={walletpayment === "0"}
                                                onChange={(e) => setWalletpayment(e.target.value)} />
                                            <span className="custom-control-label">  غیرفعال</span>
                                        </label>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group mb-0">
                            <button className="btn btn-success px-4 btn-block">ذخیره اطلاعات </button>
                        </div>
                    </div>
                </div>ّ
            </form>
        </div>
    );
};


export default PaymentType;